 class BillingForm {
            constructor(options = {}) {
                this.targetButtonSelector = options.buttonSelector || null;
                this.targetButton = null;
                this.privacyCheckbox = null;
                this.isInitialized = false;
                this.formData = null;
                this.saveIndicator = null;
                this.saveIndicatorText = null;
                
                // Configuración
                this.config = {
                    formSelector: '#billingForm',
                    billingSectionSelector: '#billingSection',
                    regimenFiscalSelector: '#regimenFiscal',
                    usoCfdiSelector: '#usoCfdi',
                    rfcSelector: '#rfc',
                    rfcMessageSelector: '#rfcMessage',
                    privacyCheckboxSelector: '#Privacidad',
                    saveIndicatorSelector: '#saveIndicator',
                    saveIndicatorTextSelector: '#saveIndicatorText',
                    ...options
                };
                
                this.init();
            }

            init() {
                this.findElements();
                if (this.elementsExist()) {
                    this.setupEventListeners();
                    this.restoreFormData();
                    this.updateButtonState();
                    this.isInitialized = true;
                    console.log('BillingForm inicializado correctamente');
                } else {
                    console.warn('BillingForm: Elementos no encontrados, reintentando...');
                    this.scheduleRetry();
                }
            }

            findElements() {
                this.form = document.querySelector(this.config.formSelector);
                this.billingSection = document.querySelector(this.config.billingSectionSelector);
                this.regimenFiscal = document.querySelector(this.config.regimenFiscalSelector);
                this.usoCfdi = document.querySelector(this.config.usoCfdiSelector);
                this.rfc = document.querySelector(this.config.rfcSelector);
                this.rfcMessage = document.querySelector(this.config.rfcMessageSelector);
                this.privacyCheckbox = document.querySelector(this.config.privacyCheckboxSelector);
                this.saveIndicator = document.querySelector(this.config.saveIndicatorSelector);
                this.saveIndicatorText = document.querySelector(this.config.saveIndicatorTextSelector);
                
                if (this.targetButtonSelector) {
                    this.targetButton = document.querySelector(this.targetButtonSelector);
                }
            }

            elementsExist() {
                return this.form && this.billingSection && this.regimenFiscal && 
                       this.usoCfdi && this.rfc && this.rfcMessage;
            }

            scheduleRetry() {
                setTimeout(() => {
                    this.init();
                }, 100);
            }

            setupEventListeners() {
                // Limpiar listeners anteriores si existen
                this.removeEventListeners();
                
                // Radio buttons para requerir factura - usando delegación de eventos
                document.addEventListener('click', this.handleRadioClick.bind(this));
                
                // Otros campos
                this.regimenFiscal.addEventListener('change', this.handleRegimenFiscalChange.bind(this));
                this.usoCfdi.addEventListener('change', this.handleUsoCfdiChange.bind(this));
                this.rfc.addEventListener('input', this.handleRFCInput.bind(this));
                this.rfc.addEventListener('blur', this.handleRFCBlur.bind(this));
                
                // Event listener para el checkbox de privacidad
                if (this.privacyCheckbox) {
                    this.privacyCheckbox.addEventListener('change', this.handlePrivacyCheckboxChange.bind(this));
                    console.log('Event listener agregado al checkbox de privacidad');
                }
            }

            removeEventListeners() {
                // Los event listeners de delegación se manejan automáticamente
                if (this.regimenFiscal) {
                    this.regimenFiscal.removeEventListener('change', this.handleRegimenFiscalChange.bind(this));
                }
                if (this.usoCfdi) {
                    this.usoCfdi.removeEventListener('change', this.handleUsoCfdiChange.bind(this));
                }
                if (this.rfc) {
                    this.rfc.removeEventListener('input', this.handleRFCInput.bind(this));
                    this.rfc.removeEventListener('blur', this.handleRFCBlur.bind(this));
                }
                if (this.privacyCheckbox) {
                    this.privacyCheckbox.removeEventListener('change', this.handlePrivacyCheckboxChange.bind(this));
                }
            }

            handlePrivacyCheckboxChange() {
                console.log('Checkbox de privacidad cambiado:', this.privacyCheckbox.checked);
                this.updateButtonState();
                this.saveFormData();
            }

            handleRadioClick(event) {
                const radioOption = event.target.closest('.radio-option');
                if (!radioOption || !this.form?.contains(radioOption)) return;

                const value = radioOption.dataset.value;
                const radioInput = radioOption.querySelector('input[type="radio"]');
                
                if (!radioInput) return;

                // Actualizar selección visual
                const allOptions = this.form.querySelectorAll('.radio-option');
                allOptions.forEach(opt => opt.classList.remove('selected'));
                radioOption.classList.add('selected');
                
                // Marcar radio button
                radioInput.checked = true;
                
                this.handleBillingRequirement(value);
                this.saveFormData();
            }

            handleRegimenFiscalChange() {
                if (this.regimenFiscal.value) {
                    this.usoCfdi.disabled = false;
                    this.usoCfdi.classList.remove('error');
                } else {
                    this.usoCfdi.disabled = true;
                    this.usoCfdi.value = '';
                    this.rfc.disabled = true;
                    this.rfc.value = '';
                    this.clearRFCValidation();
                }
                this.updateButtonState();
                this.saveFormData();
            }

            handleUsoCfdiChange() {
                if (this.usoCfdi.value) {
                    this.rfc.disabled = false;
                    this.rfc.classList.remove('error');
                    this.showRFCMessage('info', 'Ingrese un RFC válido de 12 o 13 caracteres');
                } else {
                    this.rfc.disabled = true;
                    this.rfc.value = '';
                    this.clearRFCValidation();
                }
                this.updateButtonState();
                this.saveFormData();
            }

            handleRFCInput() {
                // Validar inmediatamente en cada cambio
                setTimeout(() => {
                    this.validateRFC();
                    this.updateButtonState();
                    this.saveFormData();
                }, 10);
            }

            handleRFCBlur() {
                // Validar al perder el foco
                this.validateRFC();
                this.updateButtonState();
                this.saveFormData();
            }

            handleBillingRequirement(value) {
                if (value === 'Si') {
                    this.billingSection.style.display = 'block';
                    this.billingSection.classList.add('enabled');
                    this.regimenFiscal.disabled = false;
                    
                    // Deshabilitar checkbox de privacidad cuando se requiere factura
                    if (this.privacyCheckbox) {
                        this.privacyCheckbox.disabled = true;
                        console.log('Checkbox de privacidad deshabilitado - se requiere factura');
                    }
                } else {
                    this.billingSection.style.display = 'none';
                    this.billingSection.classList.remove('enabled');
                    this.resetBillingFields();
                    
                    // Habilitar checkbox de privacidad cuando NO se requiere factura
                    // if (this.privacyCheckbox) {
                    //     this.privacyCheckbox.disabled = false;
                    //     console.log('Checkbox de privacidad habilitado - no se requiere factura');
                    // }
                    
                    // Actualizar carrito para remover datos de facturación
                    this.updateCartWithBillingData();
                }
                
                // Forzar actualización inmediata del estado del botón
                setTimeout(() => {
                    this.updateButtonState();
                }, 10);
            }

            async validateRFC() {
                if (!this.rfc) return false;

                const rfcValue = this.rfc.value.toUpperCase().trim();

                // Limpiar estados anteriores SIEMPRE
                this.rfc.classList.remove('error', 'success');
                this.clearRFCValidation();

                // Si está vacío, deshabilitar checkbox y salir
                if (!rfcValue) {
                    if (this.privacyCheckbox) {
                        this.privacyCheckbox.disabled = true;
                    }
                    return false;
                }

                // Si es muy corto, mostrar como inválido
                if (rfcValue.length < 10) {
                    this.rfc.classList.add('error');
                    this.showRFCMessage('error', '✗ RFC muy corto. Mínimo 10 caracteres');
                    if (this.privacyCheckbox) {
                        this.privacyCheckbox.disabled = true;
                    }
                    return false;
                }

                try {
                    // Usar la función correcta con los parámetros correctos
                    const isValid = validateRfc(rfcValue, { omitVerificationDigit: true });

                    if (isValid.isValid) {
                        this.rfc.classList.add('success');
                        this.showRFCMessage('success', '✓ RFC válido - Guardando en carrito...');

                        // Habilitar checkbox de privacidad cuando RFC es válido
                        if (this.privacyCheckbox) {
                            this.privacyCheckbox.disabled = false;
                            console.log('Checkbox de privacidad habilitado - RFC válido');
                        }

                        // Actualizar carrito con datos de facturación
                        await this.updateCartWithBillingData();

                        return true;
                    } else {
                        this.rfc.classList.add('error');
                        this.showRFCMessage('error', '✗ RFC inválido. Verifique el formato');

                        // Deshabilitar checkbox si RFC es inválido
                        if (this.privacyCheckbox) {
                            this.privacyCheckbox.disabled = true;
                        }

                        return false;
                    }
                } catch (error) {
                    console.error('Error al validar RFC:', error);
                    this.rfc.classList.add('error');
                    this.showRFCMessage('error', '✗ Error al validar RFC');

                    // Deshabilitar checkbox en caso de error
                    if (this.privacyCheckbox) {
                        this.privacyCheckbox.disabled = true;
                    }

                    return false;
                }
            }

            // Nueva función para actualizar el carrito con datos de facturación
            async updateCartWithBillingData() {
                try {
                    const billingData = this.getFormData();
                    
                    if (!billingData) {
                        console.log('No hay datos de facturación para guardar');
                        return;
                    }

                    this.showSaveIndicator('loading', 'Guardando datos...');

                    // Preparar atributos para el carrito
                    const cartAttributes = {
                        'Factura': billingData.requiresBilling || 'No'
                    };

                    // Si requiere factura, agregar todos los datos fiscales
                    if (billingData.requiresBilling === 'Si') {
                        cartAttributes['CFDI'] = billingData.regimenFiscal || '';
                        cartAttributes['USO_CFDI'] = billingData.usoCfdi || '';
                        cartAttributes['RFC'] = billingData.rfc || '';
                        
                        // Obtener texto descriptivo para mejor legibilidad
                        const regimenText = this.regimenFiscal.options[this.regimenFiscal.selectedIndex]?.text || '';
                        const usoCfdiText = this.usoCfdi.options[this.usoCfdi.selectedIndex]?.text || '';
                        
                        cartAttributes['Regimen_Fiscal_Texto'] = regimenText;
                        cartAttributes['Uso_CFDI_Texto'] = usoCfdiText;
                    }

                    // Agregar estado de privacidad
                    // cartAttributes['Privacidad_Aceptada'] = billingData.privacyAccepted ? 'Si' : 'No';

                    console.log('Actualizando carrito con atributos:', cartAttributes);

                    // Actualizar carrito usando la API de Shopify
                    const response = await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            attributes: cartAttributes
                        })
                    });

                    if (response.ok) {
                        const cartData = await response.json();
                        console.log('Carrito actualizado exitosamente:', cartData);
                        
                        this.showSaveIndicator('success', '✓ Datos guardados en carrito');
                        
                        // Actualizar mensaje del RFC si es válido
                        if (billingData.requiresBilling === 'Si' && this.rfc.classList.contains('success')) {
                            this.showRFCMessage('success', '✓ RFC válido - Datos guardados en carrito');
                        }

                        // Disparar evento personalizado para notificar la actualización
                        document.dispatchEvent(new CustomEvent('billing:cart-updated', {
                            detail: { cartAttributes, cartData }
                        }));

                    } else {
                        throw new Error(`Error HTTP: ${response.status}`);
                    }

                } catch (error) {
                    console.error('Error actualizando carrito:', error);
                    this.showSaveIndicator('error', '✗ Error guardando datos');
                    
                    // Mostrar error en el mensaje del RFC si aplica
                    if (this.rfc.classList.contains('success')) {
                        this.showRFCMessage('error', '✗ RFC válido pero error guardando en carrito');
                    }
                }
            }

            // Función para mostrar indicador de guardado
            showSaveIndicator(type, message) {
                if (!this.saveIndicator || !this.saveIndicatorText) return;

                this.saveIndicatorText.textContent = message;
                this.saveIndicator.className = `save-indicator ${type} show`;

                // Ocultar después de 3 segundos
                setTimeout(() => {
                    this.saveIndicator.classList.remove('show');
                }, 3000);
            }

            showRFCMessage(type, message) {
                if (!this.rfcMessage) return;
                this.rfcMessage.className = `form-message ${type}`;
                this.rfcMessage.textContent = message;
                this.rfcMessage.style.display = 'flex';
            }

            clearRFCValidation() {
                if (!this.rfc || !this.rfcMessage) return;
                this.rfc.classList.remove('error', 'success');
                this.rfcMessage.style.display = 'none';
                this.rfcMessage.textContent = '';
            }

            resetBillingFields() {
                if (!this.regimenFiscal || !this.usoCfdi || !this.rfc) return;
                
                this.regimenFiscal.disabled = true;
                this.regimenFiscal.value = '';
                this.usoCfdi.disabled = true;
                this.usoCfdi.value = '';
                this.rfc.disabled = true;
                this.rfc.value = '';
                this.clearRFCValidation();
                
                // Deshabilitar checkbox al resetear campos
                if (this.privacyCheckbox) {
                    this.privacyCheckbox.disabled = true;
                }
                
                [this.regimenFiscal, this.usoCfdi, this.rfc].forEach(field => {
                    field.classList.remove('error', 'success');
                });
            }

            // Función para obtener el elemento seleccionado por atributo Factura
            getSelectedBillingElement() {
                const selectedElement = this.form?.querySelector('[Factura]:checked');
                return selectedElement;
            }

            isFormValid() {
                if (!this.form) return false;
                
                // Usar el nuevo selector por atributo
                const requiresBilling = this.getSelectedBillingElement();
                
                // Si no hay selección de factura, botón deshabilitado
                if (!requiresBilling) {
                    return false;
                }

                const facturaValue = requiresBilling.getAttribute('Factura');

                if (facturaValue === 'Si') {
                    // Si requiere factura: TODOS los campos deben estar completos Y RFC válido
                    const rfcValid = this.rfc?.value && this.rfc.classList.contains('success');
                    const allFieldsValid = this.regimenFiscal?.value && 
                                          this.usoCfdi?.value && 
                                          this.rfc?.value && 
                                          rfcValid;
                    
                    const privacyAccepted = this.privacyCheckbox ? this.privacyCheckbox.checked : true;
                    
                    return allFieldsValid && privacyAccepted;
                } else {
                    // Si NO requiere factura: solo necesita checkbox marcado
                    return this.privacyCheckbox ? this.privacyCheckbox.checked : true;
                }
            }

            updateButtonState() {
                if (this.targetButton) {
                    const isValid = this.isFormValid();
                    this.targetButton.disabled = !isValid;
                    
                    // Log para debug
                    console.log('Estado del botón actualizado:', {
                        disabled: this.targetButton.disabled,
                        formValid: isValid,
                        privacyChecked: this.privacyCheckbox?.checked,
                        privacyDisabled: this.privacyCheckbox?.disabled
                    });
                }
            }

            // Guardar datos del formulario en localStorage
            saveFormData() {
                if (!this.form) return;
                
                const requiresBilling = this.getSelectedBillingElement();
                const data = {
                    requiresBilling: requiresBilling?.getAttribute('Factura') || null,
                    regimenFiscal: this.regimenFiscal?.value || '',
                    usoCfdi: this.usoCfdi?.value || '',
                    rfc: this.rfc?.value || '',
                    privacyChecked: this.privacyCheckbox?.checked || false
                };
                
                localStorage.setItem('billingFormData', JSON.stringify(data));
                this.formData = data;
            }

            // Restaurar datos del formulario
            restoreFormData() {
                try {
                    const savedData = localStorage.getItem('billingFormData');
                    if (!savedData || !this.form) return;
                    
                    const data = JSON.parse(savedData);
                    
                    // Restaurar selección de factura usando el atributo Factura
                    if (data.requiresBilling) {
                        const radioOption = this.form.querySelector(`[data-value="${data.requiresBilling}"]`);
                        const radioInput = this.form.querySelector(`[Factura="${data.requiresBilling}"]`);
                        
                        if (radioOption && radioInput) {
                            radioOption.classList.add('selected');
                            radioInput.checked = true;
                            this.handleBillingRequirement(data.requiresBilling);
                        }
                    }
                    
                    // Restaurar checkbox de privacidad
                    if (this.privacyCheckbox && data.privacyChecked) {
                        this.privacyCheckbox.checked = data.privacyChecked;
                    }
                    
                    // Restaurar campos fiscales
                    if (data.requiresBilling === 'Si') {
                        setTimeout(() => {
                            if (data.regimenFiscal && this.regimenFiscal) {
                                this.regimenFiscal.value = data.regimenFiscal;
                                this.handleRegimenFiscalChange();
                            }
                            
                            setTimeout(() => {
                                if (data.usoCfdi && this.usoCfdi) {
                                    this.usoCfdi.value = data.usoCfdi;
                                    this.handleUsoCfdiChange();
                                }
                                
                                setTimeout(() => {
                                    if (data.rfc && this.rfc) {
                                        this.rfc.value = data.rfc;
                                        this.validateRFC();
                                    }
                                }, 50);
                            }, 50);
                        }, 50);
                    }
                } catch (error) {
                    console.warn('Error restaurando datos del formulario:', error);
                }
            }

            // Método público para reinicializar
            reinitialize() {
                console.log('Reinicializando BillingForm...');
                this.isInitialized = false;
                this.init();
            }

            // Métodos públicos
            getFormData() {
                if (!this.form) return null;
                
                const requiresBilling = this.getSelectedBillingElement();
                
                if (!requiresBilling) {
                    return null;
                }

                const facturaValue = requiresBilling.getAttribute('Factura');
                const data = {
                    requiresBilling: facturaValue,
                    privacyAccepted: this.privacyCheckbox?.checked || false
                };

                if (facturaValue === 'Si') {
                    data.regimenFiscal = this.regimenFiscal?.value || '';
                    data.usoCfdi = this.usoCfdi?.value || '';
                    data.rfc = this.rfc?.value?.toUpperCase() || '';
                }

                return data;
            }

            setTargetButton(selector) {
                this.targetButtonSelector = selector;
                this.targetButton = document.querySelector(selector);
                this.updateButtonState();
            }

            isValid() {
                return this.isFormValid();
            }

            clearSavedData() {
                localStorage.removeItem('billingFormData');
                this.formData = null;
            }

            // Método público para controlar el checkbox de privacidad
            setPrivacyCheckboxState(enabled) {
                if (this.privacyCheckbox) {
                    this.privacyCheckbox.disabled = !enabled;
                    console.log(`Checkbox de privacidad ${enabled ? 'habilitado' : 'deshabilitado'} manualmente`);
                }
            }

            // Método público para obtener el estado del checkbox
            getPrivacyCheckboxState() {
                if (this.privacyCheckbox) {
                    return {
                        disabled: this.privacyCheckbox.disabled,
                        checked: this.privacyCheckbox.checked
                    };
                }
                return null;
            }

            // Método público para forzar actualización del carrito
            async forceUpdateCart() {
                await this.updateCartWithBillingData();
            }
        }

        // Manager para manejar reinicios automáticos
        class BillingFormManager {
            constructor() {
                this.billingForm = null;
                this.observer = null;
                this.init();
            }

            init() {
                this.createBillingForm();
                this.setupMutationObserver();
                this.setupShopifyListeners();
            }

            createBillingForm() {
                if (this.billingForm) {
                    this.billingForm.clearSavedData?.();
                }
                this.billingForm = new BillingForm();
                window.billingForm = this.billingForm;
            }

            setupMutationObserver() {
                if (this.observer) {
                    this.observer.disconnect();
                }

                this.observer = new MutationObserver((mutations) => {
                    let shouldReinit = false;
                    
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'childList') {
                            // Verificar si se agregaron o removieron nodos que contienen nuestro formulario
                            const addedNodes = Array.from(mutation.addedNodes);
                            const removedNodes = Array.from(mutation.removedNodes);
                            
                            const hasFormElements = (nodes) => {
                                return nodes.some(node => {
                                    if (node.nodeType === 1) { // Element node
                                        return node.querySelector && (
                                            node.querySelector('#billingForm') ||
                                            node.id === 'billingForm' ||
                                            node.querySelector('.billing-container')
                                        );
                                    }
                                    return false;
                                });
                            };
                            
                            if (hasFormElements(addedNodes) || hasFormElements(removedNodes)) {
                                shouldReinit = true;
                            }
                        }
                    });
                    
                    if (shouldReinit) {
                        console.log('Detectado cambio en el DOM, reinicializando formulario...');
                        setTimeout(() => {
                            this.createBillingForm();
                        }, 100);
                    }
                });

                this.observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            }

            setupShopifyListeners() {
                // Escuchar eventos específicos de Shopify
                document.addEventListener('cart:updated', () => {
                    console.log('Cart updated, reinicializando formulario...');
                    setTimeout(() => {
                        this.createBillingForm();
                    }, 200);
                });

                // Escuchar el evento personalizado de actualización de facturación
                document.addEventListener('billing:cart-updated', (event) => {
                    console.log('Datos de facturación actualizados en carrito:', event.detail);
                });

                // Escuchar cambios en fetch (para AJAX requests)
                const originalFetch = window.fetch;
                window.fetch = function(...args) {
                    return originalFetch.apply(this, args).then(response => {
                        // Si es una request del carrito, reinicializar después
                        if (args[0] && typeof args[0] === 'string' && 
                            (args[0].includes('/cart') || args[0].includes('cart'))) {
                            setTimeout(() => {
                                if (window.billingFormManager) {
                                    window.billingFormManager.createBillingForm();
                                }
                            }, 300);
                        }
                        return response;
                    });
                };
            }
        }

        // Inicializar cuando el DOM esté listo
        document.addEventListener('DOMContentLoaded', () => {
            window.billingFormManager = new BillingFormManager();
        });

        // También inicializar si el DOM ya está listo
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                if (!window.billingFormManager) {
                    window.billingFormManager = new BillingFormManager();
                }
            });
        } else {
            window.billingFormManager = new BillingFormManager();
        }

  document.addEventListener('DOMContentLoaded', () => {
    // Esperar un poco para asegurar que el formulario esté listo
    setTimeout(() => {
        if (window.billingForm) {
            // Cambiar aquí el ID del botón que quieres controlar
            window.billingForm.setTargetButton('#update_cart_button');
        }
    }, 500);
});

  

  function privacidad() {
  console.log('hola')
  var checkBox = document.querySelector("#Privacidad");
 
    var btn_cart_checkout = document.querySelector("#update_cart_button");
  if (checkBox.checked == true){
     btn_cart_checkout.disabled = false;
  } else {
    btn_cart_checkout.disabled = true;
  }
}